import React, { useContext, useRef } from 'react';
import { eq } from 'lodash';
import styles from 'components/ScenarioSetup/ActionIcons/ActionIcons.module.css';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { defaultConnectionColor } from 'components/ScenarioSetup/ActionConnections/defaultStyles';
import { useOutsideAlerter } from 'hooks/useOutsideAlerter';
import { ActionTooltipWindow } from 'components/ScenarioSetup/ActionIcons/sections/ActionTooltipWindow';
import { ActionTooltipWarnings } from 'components/ScenarioSetup/ActionIcons/sections/ActionTooltipWarnings';
import classNames from 'classnames/bind';
import { ActionIconsContext } from 'components/ScenarioSetup/ActionIcons/context/ActionIconsContext';

const cx = classNames.bind(styles);

export const SingleChainActionIcon = ({
    id,
    actionType,
    title,
    isShowWarningActionMessage,
    isOpenActionInfo,
    actionIconConditions,
    alternativeEditHandler,
}) => {
    const dispatch = useDispatch();
    const idOutput = id + '-output';
    const output = useSelector(store => store.scenariosActions.actionOutputCheckpoint);
    const sidebarActionId = useSelector(store => store.scenariosActions.actionSidebar.id);
    const context = useContext(ActionIconsContext);

    const {
        onRightClick,
        outputCheckpointHandler,
        actionIconStatusConfig,
        onDoubleClick,
        changeActionStatus
    } = context;

    const connectionConfig = {
        id: idOutput,
        color: defaultConnectionColor,
    };

    const wrappedRef = useRef(null);

    useOutsideAlerter(wrappedRef, changeActionStatus(dispatch, id));

    const { icon, iconProps } = actionIconStatusConfig(actionIconConditions, isOpenActionInfo, id, sidebarActionId, isShowWarningActionMessage);
    const ActionIcon = icon;

    const isActiveOutputDot = output && eq(output.id, idOutput);

    return (
        <ActionIconsContext.Provider value={{
            ...context,
            isOpenActionInfo,
            isShowWarningActionMessage,
            wrappedRef,
            id,
            title,
            actionType,
            alternativeEditHandler,
        }}>
            <div className={cx(styles.action)}>
                <div onContextMenu={onRightClick(id, dispatch, isShowWarningActionMessage)} onDoubleClick={onDoubleClick(dispatch, actionType, id, alternativeEditHandler)}>
                    <ActionIcon children={icon} { ...iconProps }/>
                </div>
                <div className={cx(styles.actionOutputDot, { 'active': isActiveOutputDot })}
                     id={idOutput}
                     onClick={outputCheckpointHandler(output, idOutput, connectionConfig, dispatch)}
                />

                <ActionTooltipWindow/>

                <ActionTooltipWarnings/>
            </div>
        </ActionIconsContext.Provider>
    );
};

SingleChainActionIcon.propTypes = {
    id: PropTypes.string.isRequired,
    actionType: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    isShowWarningActionMessage: PropTypes.bool.isRequired,
    isOpenActionInfo: PropTypes.bool.isRequired,
    actionIconConditions: PropTypes.object.isRequired,
    alternativeEditHandler: PropTypes.func
}
